var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsIt = function SvgNnIconFlagsIt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32.25 32.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.125.166c-2.935 0-5.676.806-8.039 2.188v27.541c2.363 1.382 5.104 2.188 8.039 2.188s5.676-.806 8.039-2.188V2.354A15.87 15.87 0 0 0 16.125.166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#199900",
    d: "M.166 16.125c0 5.879 3.188 11.002 7.92 13.771V2.354C3.354 5.123.166 10.246.166 16.125"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M24.164 29.896c4.732-2.769 7.92-7.892 7.92-13.771s-3.188-11.002-7.92-13.771z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.171,
    cy: 16.154,
    r: 15.959,
    fill: "none",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
};
export default SvgNnIconFlagsIt;